import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormatter'
})
export class DateFormatterPipe implements PipeTransform {

  transform(_date: string, _lang: string = 'fr') {
    let month:any = [];
    let day:any = [];
    let date = typeof _date == "string" ? new Date(_date.split("T")[0]) : new Date(_date);
    let dayIndex = date.getDay();
    let monthIndex = date.getMonth();
    if (!_lang || _lang == "fr") {
        month = [
            "Janvier", "Février", "Mars", "Avril",
            "Mai", "Juin", "Juillet",
            "Août", "Septembre", "Octobre",
            "Novembre", "Décembre"
        ];
        day = ["Dimanche", "lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
    } else if (_lang == "en") {
        month = [
            "January", "February", "March",
            "April", "May", "June", "July",
            "August", "September", "October",
            "November", "December"
        ];
        day = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thirsday", "Friday", "Saturday"];
    }
    return day[dayIndex] + " " + date.getDate() + " " + month[monthIndex] + " " + date.getFullYear();
}

}
